import React from 'react';
import { useTranslation } from 'react-i18next';
import { IoBookOutline } from "react-icons/io5";
import { PiLaptopBold } from 'react-icons/pi';
import { GrCertificate } from 'react-icons/gr';

const Features = ({ totalCourses }) => {
    const { t } = useTranslation();
    const features = [
        {
            id: 1,
            title: t("learn-from-experts"),
            desc: t("learn-from-experts-desc"),
            icon: <IoBookOutline size={25} color="white" />,
            color: "#744CFF"
        },
        // {
        //     id: 2,
        //     title: t("earn-certificate"),
        //     desc: t("earn-certificate-desc"),
        //     icon: <GrCertificate size={25} color="white" />,
        //     color: "#61DAFB"
        // },
        {
            id: 3,
            title: `${totalCourses.toLocaleString()} ${t("courses-total")}`,
            // title: `5000+ ${t("courses")}`,
            desc: t("courses-desc"),
            icon: <PiLaptopBold size={25} color="white" />,
            color: "#50BFA5"
        },
    ];

    return (
        <section className="relative -top-8 lg:-top-28 px-4 mb-5 mx-auto sm:max-w-5xl sm:px-6 lg:max-w-7xl lg:px-8">
            <div className="relative grid gap-5 sm:grid-cols-2 lg:grid-cols-2 justify-center">
                {
                    features.map(feature => (
                        <div key={feature.id} className="flex flex-row items-center gap-3 overflow-hidden text-left transition-shadow duration-200 p-4 lg:p-5 bg-white rounded shadow-xl group hover:shadow-2xl">
                            {/* Fixed-size Icon Container */}
                            <div
                                className="flex items-center justify-center w-12 h-12 rounded-full"
                                style={{ backgroundColor: feature.color }}
                            >
                                {feature.icon}
                            </div>
                            {/* Feature Content */}
                            <div className='ml-5 flex-1'>
                                <p className="mb-2 font-bold ltr:text-left rtl:text-right">{feature.title}</p>
                                <p className="text-sm leading-5 text-gray-900 ltr:text-left rtl:text-right line-clamp-3">
                                    {feature.desc}
                                </p>
                            </div>
                        </div>
                    ))
                }
            </div>
        </section>
    );
}

export default Features;
